export default __webpack_public_path__ + "static/media/info-gray-16.a7d73feb.svg";